import {Theme} from '@mui/material/styles';
import {merge} from 'lodash';
import AccordionSummary from './AccordionSummary';
import Alert from './Alert';
import {Button} from './Button';
import Card from './Card';
import CardMedia from './CardMedia';
import {CssBaselineOverride} from './CssBaseline';
import DialogActions from './DialogActions';
import DialogContent from './DialogContent';
import DialogTitle from './DialogTitle';
import FilledInput from './FilledInput';
import FormControlLabel from './FormControlLabel';
import IconButton from './IconButton';
import Link from './Link';
import ListItem from './ListItem';
import ListItemIcon from './ListItemIcon';
import PickersLayout from './PickersLayout';
import Tab from './Tab';
import Tabs from './Tabs';
import TextField from './TextField';
import ToggleButton from './ToggleButton';
import Tooltip from './Tooltip';

export const createOverrides = (theme: Theme) =>
  merge(
    AccordionSummary(),
    Alert(),
    Button(theme),
    Card(),
    CardMedia(),
    CssBaselineOverride(theme),
    DialogActions(theme),
    DialogContent(theme),
    DialogTitle(theme),
    FilledInput(theme),
    FormControlLabel(),
    IconButton(),
    Link(),
    ListItem(),
    ListItemIcon(),
    PickersLayout(theme),
    Tab(theme),
    Tabs(theme),
    TextField(),
    ToggleButton(),
    Tooltip(),
  );
